import { apiPost } from 'api';
import { SubmitResponseResponse, SubmitResponseRequest } from '../../types';

export const submitResponse = (
  request: SubmitResponseRequest
): Promise<SubmitResponseResponse> => {
  return apiPost<SubmitResponseResponse, SubmitResponseRequest>(
    `consultations/${request.consultationId}/response/submit`,
    request
  );
};
